module.exports = __webpack_public_path__ + "static/media/DSC01593.dda04716.jpeg";